module.exports = __webpack_public_path__ + "assets/images/89288a3285ec03e4c246b9bf581e961d.png";